import { sendRequest } from '@alme/ui-web/modules/lib-alme-request/src/lib-alme-request'
import { AlmeState } from '@alme/ui-web/wireup/AlmeState';
import { Store } from 'redux';
import { AlightCustomSettingsType } from '../../settings/alight-custom-settings';
import { Input } from '@alme/ui-web/types/input';
import { EntryOriginTypesV5 } from '@alme/api-ts/Alme/EntryOriginTypes';

export default class ReportingEventHelper{
    _settings: AlightCustomSettingsType;
    _store: Store<AlmeState> | undefined;

    constructor(settings: AlightCustomSettingsType) {
        this._settings = settings;
    }

    initialize(store: Store<AlmeState>){
        this._store = store;
    }

    fireErrorReportingEvent(incomingValue: string | boolean){
        let eventName = "InitializationDataRetrievalError";
        let eventValue = incomingValue;
        let eventOrigin = this._settings.originConstants.internal;

        let input: Input = {
            messageType : this._settings.messageConstants.reportingEventRequest,
            eventName: eventName,
            eventValue: eventValue,
            origin : eventOrigin as EntryOriginTypesV5
        };

        sendRequest(input);
    }
}


// WEBPACK FOOTER //
// ./modules/initialization-data-handler/reporting-event-helper.ts